(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NL-announcement-bar-premium"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const sectionRoot = document.querySelector('.novalatte-ticker-root');
    if (!sectionRoot) return;

    const sectionId = sectionRoot.dataset.sectionId;
    const bar = document.getElementById(`TickerBar-${sectionId}`);
    
    // Solo activar lógica si es Sticky
    if (bar.classList.contains('is-sticky')) {
      let lastScrollY = window.scrollY;
      const threshold = 600; // Altura aproximada del Hero

      const handleScroll = () => {
        const currentScroll = window.scrollY;

        // Si bajamos más de 600px, ocultar
        if (currentScroll > threshold) {
          bar.classList.add('is-hidden');
        } else {
          // Si estamos arriba, mostrar
          bar.classList.remove('is-hidden');
        }
        
        lastScrollY = currentScroll;
      };

      // Listener pasivo para performance
      window.addEventListener('scroll', handleScroll, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["NL-dynamic-container-premium"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    // Advanced IntersectionObserver for staggered animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["NL-header-premium-gls"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const sectionId = document.querySelector('.premium-header-root').dataset.sectionId;
    const headerWrapper = document.getElementById(`Header-${sectionId}`);
    const mobileBtn = headerWrapper.querySelector('.js-mobile-toggle');
    const body = document.body;

    const accountWrapper = headerWrapper.querySelector('.account-dropdown-wrapper');
    const accountTrigger = headerWrapper.querySelector('.js-account-trigger');

    if (accountWrapper && accountTrigger) {
      accountTrigger.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        accountWrapper.classList.toggle('is-open');
        const isExpanded = accountWrapper.classList.contains('is-open');
        accountTrigger.setAttribute('aria-expanded', isExpanded);
      });
      document.addEventListener('click', (e) => {
        if (!accountWrapper.contains(e.target)) {
          accountWrapper.classList.remove('is-open');
          accountTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    let isScrolled = false; const scrollThreshold = 50;
    const handleScroll = () => {
      if (headerWrapper.classList.contains('is-inner-page')) return;
      const scrollTop = window.scrollY;
      if (scrollTop > scrollThreshold && !isScrolled) {
        headerWrapper.classList.add('is-scrolled'); isScrolled = true;
      } else if (scrollTop <= scrollThreshold && isScrolled) {
        headerWrapper.classList.remove('is-scrolled'); isScrolled = false;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });

    if (mobileBtn) {
      mobileBtn.addEventListener('click', () => {
        body.classList.toggle('mobile-menu-open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["NL-section-about"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if(e.isIntersecting) e.target.classList.add("is-visible"); });
    }, { threshold: 0.1 });
    document.querySelectorAll(".reveal-up").forEach(el => observer.observe(el));
    document.querySelectorAll(".nl-manifesto-item").forEach(el => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
